// Silence dangling underscores throughout file
/* eslint-disable no-underscore-dangle */

/**
 * Escapes string to be used as a value in analytics reports.
 * Values need to be all-lowercase, special characters need to be stripped.
 * @param {string} str String to escape.
 * @returns {string} Escaped string.
 */
const escapeString = (str: string): string =>
  str
    .replace(/[^a-zA-Z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .toLowerCase();

/**
 * Tracks link clicks.
 * @param {string} linkSection Category to combine multiple link clicks
 * together, e.g. "main menu".
 * @param {string} [linkTitle] Unique identifier in reports for the clicked
 * element.
 * @param {string} [linkDestinationUrl] Destination URL if the link points to
 * another page, eg "knowledge.autodesk.com/support/...".
 * @param {Record<string, any>} [eventContext={}] Additional context to the click event.
 * @returns {void}
 */
export const trackLinkClick = (
  linkSection: string,
  linkTitle: string | null = null,
  linkDestinationUrl: string | null = null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventContext: Record<string, any> = {}
): void => {
  window.__analyticsChangeContext = window.__analyticsChangeContext || [];
  window.__analyticsChangeContext.push({
    event: {
      eventType: 'link_click',
    },
    link: {
      linkSection: escapeString(linkSection),
      linkTitle: linkTitle ? escapeString(linkTitle) : null,
      linkDestinationUrl,
    },
    eventContext,
  });
};
